import breakpoints from '@carvana/merch-tailwind/screens';
import { CarvanaTheme } from '@carvana/showroom-theme';
import { createComponent } from '@carvana/vdp-components';
import styled, { css } from 'styled-components';
import CloseIcon from '~/icons/CloseIcon';
import {
  barHeightDesktop,
  barHeightMobile,
  stickyBarHeightDesktop,
  stickyBarHeightMobile
} from '../KeywordSearch.styles';

const getContainerProps = ({ ...props }) => {
  return css`
    position: absolute;
    left: 0;
    padding: 0 14px;
    width: 100%;
    top: ${props.isStickySearchbar
      ? stickyBarHeightMobile + 1
      : barHeightMobile + 1}px;
    max-width: 1800px;

    @media (min-width: ${breakpoints.m}px) {
      top: ${props.isStickySearchbar
        ? stickyBarHeightDesktop + 1
        : barHeightDesktop + 1}px;
      padding: 0 14px 0 8px;
    }
  `;
};

export const Suggestion = createComponent('span', {
  className:
    't-body-m relative flex justify-between m:justify-start items-center flex-nowrap text-blue-6 cursor-pointer py-8 m:px-8 m:py-[10px] gap-8'
});

export const KeywordSuggestionsWrapper = styled.div`
  width: 100%;

  .react-autosuggest__input {
    width: 100%;
    border: none;
    background: transparent;
    font-size: 16px;
    text-indent: 10px;

    &:focus {
      outline: none;
    }

    &:placeholder-shown {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .react-autosuggest__suggestions-container {
    background: ${CarvanaTheme.color.neutral.v100};
    .react-autosuggest__section-title {
    }
    .react-autosuggest__section-container--first
      .react-autosuggest__section-title {
      padding: 12px 0 0;
    }
    ${getContainerProps}
  }

  .react-autosuggest__suggestion--highlighted {
    ${Suggestion} {
      background: var(--cvna-color-grey-1);
      border-radius: 6px;
    }
  }

  .react-autosuggest__suggestions-container--open {
    display: block;
  }

  .react-autosuggest__suggestions-list {
    list-style: none;
    padding: 0 0 8px 0;
    margin: 0;
  }
`;

export const SectionTitle = styled.div.attrs({
  className:
    't-body-m text-grey-5 capitalize py-8 m:px-8 m:py-[10px] flex items-center gap-8',
  'data-qa': 'section-title'
})`
  &.no-top-margin {
    padding: 0 8px 12px 8px;
  }
`;

export const Remove = createComponent(CloseIcon, {
  className: 'cursor-pointer  leading-6',
  'data-qa': 'remove-button'
});
